import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

import Button from "@atlaskit/button-next/new";
import { Inline, Stack, Text, xcss } from "@atlaskit/primitives-next";

import { useRoutes } from "@/components/fastshift/src/common/hooks";

import { BaseCard } from "../base-card";

import { messages } from "./messages";

const contentStyles = xcss({
    height: "100%"
});

export const MigrationResourcesCard = () => {
    const navigate = useNavigate();
    const { paths } = useRoutes();

    const navigateToDomainScopedResourcesPage = () => {
        const url = paths.domainScopedResources;
        if (url) {
            navigate(url);
        }
    };

    return (
        <BaseCard message={messages.migrationResourcesCardTitle}>
            <Stack
                xcss={contentStyles}
                space="space.100"
                spread="space-between"
            >
                <Text>
                    <FormattedMessage
                        {...messages.migrationResourcesCardDescription}
                    />
                </Text>

                <Inline alignBlock="end">
                    <Button
                        onClick={() => navigateToDomainScopedResourcesPage()}
                    >
                        <FormattedMessage
                            {...messages.migrationResourcesCardButton}
                        />
                    </Button>
                </Inline>
            </Stack>
        </BaseCard>
    );
};
